import { isInMobileApp } from 'lib/web/deviceUtils'
import { useAppSelector } from 'hooks/reduxHooks'
import { hasPassedWalledGarden } from 'selectors/accountSelectors'
import GeoContext from 'contexts/geoContext'
import { useContext } from 'react'
import { EUROPE_REGIONS } from 'constants/config/region'
import { getFunnelFeatures } from 'checkout/selectors/funnel'

const walledRegions = new Set([
  ...EUROPE_REGIONS.values(),
  'AU',
  'NZ',
  'SG',
  'HK',
])

function useOfferPageWalledGarden(bypassWall?: boolean, offerType?: App.OfferType) {
  const { currentRegionCode } = useContext(GeoContext)
  const utmMedium = useAppSelector(state => state.utm.medium)
  const utmSource = useAppSelector(state => state.utm.source)
  const isMobileApp = useAppSelector(state => isInMobileApp(state.system.rawUserAgentString))
  const passedWalledGarden = useAppSelector(state => hasPassedWalledGarden(state, offerType))
  const isWallGardened = walledRegions.has(currentRegionCode)

  // Funnel optimiser can bypass the wall when walledGarden is false
  const funnelFeatures = useAppSelector(getFunnelFeatures)
  const funnelBypassWall = !funnelFeatures.walledGarden

  const bypassWalledGarden =
    bypassWall ||
    funnelBypassWall ||
    isMobileApp ||
    utmMedium === 'email' ||
    utmMedium === 'push' ||
    utmMedium === 'sms' ||
    utmSource === 'chatgpt.com'

  const showWall = isWallGardened && !(bypassWalledGarden || passedWalledGarden)

  return showWall
}

export default useOfferPageWalledGarden
